import { Typography } from '@mui/material';
import {
    createStyles,
    makeStyles,
} from '@mui/styles';
import clsx from 'clsx';
import React, { useMemo } from 'react';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';

import { UiBackgroundV2 } from '../../../../common/UiBackground/UiBackgroundV2';
import UiList from '../../../../common/UiList/UiList';
import { useParams } from '../../../../container/Router';
import BusyGroup from '../../../../images/BusyGroup.svg';
import palette from '../../../../theme/palette';

const useStyles = makeStyles(() =>
    createStyles({
        title: {
            color: palette.light.title.primary,
            width: '100%',
            flexShrink: 0,
            fontSize: '26px',
            lineHeight: '32px',
            letterSpacing: '-0.06px',
            fontWeight: 600,
        },
        titleName: { color: palette.light.title.secondary },
        listHeader: { color: palette.light.list.header },
        headerMargin: { marginTop: '24px' },
        list: {
            marginTop: '24px',
            width: '100%',
            flexShrink: 0,
        },
        link: {
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            marginTop: '8px',
            width: 'fit-content',
            cursor: 'pointer',
            color: palette.light.link,
            '&:hover': { textDecoration: 'underline' },
        },
        trademark: {
            fontWeight: 400,
            fontSize: '8px',
            position: 'relative',
            top: '-1.8em',
        },
    }),
);

const AutomationHub = () => {
    const classes = useStyles();
    const { formatMessage: translate } = useIntl();

    const params = useParams();

    const items = useMemo(
        () => [
            [ 'CROWDSOURCE_AUTOMATION', 'PRIORITIZE_PIPELINE', 'GOVERN_AUTOMATION', 'SHOWCASE_SUCCESS' ],
            [ 'LICENSES_TRIALS_COUNTS', 'ACCESS_TO_ALL' ],
        ],
        [],
    );

    return (
        <UiBackgroundV2
            shapeColor={palette.light.shapePink}
            WelcomeImage={BusyGroup}>
            <Typography className={classes.title}>
                <FormattedMessage
                    id="AUTOMATION_HUB_HEADER"
                    description="Welcome Message"
                    values={{
                        // eslint-disable-next-line react/no-unstable-nested-components
                        title: (chunks: string) => <span className={classes.titleName}>
                            {chunks}
                        </span>,
                        // eslint-disable-next-line react/no-unstable-nested-components
                        tm: (chunks: string) => <span className={classes.trademark}>
                            {chunks}
                        </span>,
                    }}
                />
            </Typography>
            <div className={classes.list}>
                <Typography
                    variant="subtitle2"
                    className={classes.listHeader}>
                    {translate({ id: 'IDEAS_TO_AUTOMATION_EVERYWHERE' })}
                </Typography>
                <UiList
                    color={palette.light.list.body}
                    items={items[0]} />
                {params.product_name !== 'UiPath Automation Cloud' && (
                    <>
                        <Typography
                            variant="subtitle2"
                            className={clsx(classes.listHeader, classes.headerMargin)}>
                            {translate({ id: 'AUTOMATION_HUB_TRIAL' })}
                        </Typography>
                        <UiList
                            color={palette.light.list.body}
                            items={items[1]} />
                    </>
                )}
            </div>
        </UiBackgroundV2>
    );
};

export default AutomationHub;
